import { useQuery } from "@tanstack/react-query";

import type { BalancesRepositoryT } from "../domain/ports/balances.repostory";
import type { GetAllBalancesResultT } from "../domain/entities/balance.entity";
import type { GetAllBalancesUiT } from "../domain/ui/balance.model";

import { getBalances } from "../application/useCases/getBalances";
import { BALANCES_QUERY_KEY } from "../constants/queryKeys";

const toUiModel = ({
  data,
  meta,
}: GetAllBalancesResultT): GetAllBalancesUiT => ({
  data: data.map((balance) => {
    const firstBalance = balance.balances[0];

    return {
      id: balance.collaborator.collaboratorId,
      code: balance.collaborator.code,
      fullName: balance.collaborator.fullName,
      status: balance.collaborator.status === 0 ? "Alta" : "Baja",
      seniorityDate: balance.collaborator.seniorityDate,
      seniorityDateTimestamp: balance.collaborator.seniorityDate
        ? new Date(balance.collaborator.seniorityDate).getTime()
        : null,
      totalEarnedDays: `${firstBalance.totalAccruedDays ?? 0} días`,
      totalTakenDays: `${firstBalance.totalTakenDays ?? 0} días`,
      totalProportionalDays: `${firstBalance?.totalProportionalDays ?? "-"}`,
      totalAvailableDays: `${firstBalance.totalAvailableDays ?? 0} días`,
      expirationDate: firstBalance?.expirationDate ?? "-",
    };
  }),
  meta,
});

type CreateUseBalancesParamsT = {
  balancesRepository: BalancesRepositoryT;
};

export const createUseBalances = ({
  balancesRepository,
}: CreateUseBalancesParamsT) => {
  return function useBalances({
    typeId,
    colaboraInstanceId,
    page,
    pageSize,
  }: {
    typeId?: string;
    colaboraInstanceId?: string;
    page?: number;
    pageSize?: number;
  }) {
    const balancesQuery = useQuery({
      queryKey: [
        BALANCES_QUERY_KEY,
        { typeId, colaboraInstanceId, page, pageSize },
      ],
      queryFn: () =>
        getBalances({
          typeId,
          balancesRepository,
          colaboraInstanceId,
          page,
          pageSize,
        }),
      select: toUiModel,
      enabled: !!colaboraInstanceId && !!typeId,
    });

    return balancesQuery;
  };
};
